"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasAccount = void 0;
var CanvasAccount;
(function (CanvasAccount) {
    let RegistrationAccessMode;
    (function (RegistrationAccessMode) {
        RegistrationAccessMode["multipleStudents"] = "multipleStudents";
        RegistrationAccessMode["singleStudents"] = "singleStudents";
    })(RegistrationAccessMode = CanvasAccount.RegistrationAccessMode || (CanvasAccount.RegistrationAccessMode = {}));
})(CanvasAccount = exports.CanvasAccount || (exports.CanvasAccount = {}));
//# sourceMappingURL=canvasAccount.js.map